import {match, Pattern} from 'ts-pattern';

import {always} from 'ramda';

import {EQUIPMENT_DOCUMENT_FILE_CONSTRAINTS} from '../constants/equipmentDocumentFileConstraints';

export type EquipmentDocumentFileError = 'notPdf' | 'invalidSize';

/**
 * Checks a picked file against the equipment document rules. Returns the failing rule, or `null`
 * when the file may be uploaded. The `accept` attribute of the file dialog is only a hint the OS
 * picker lets the author override, so the type is checked here as well. Some systems report no
 * MIME type at all; the `.pdf` extension decides then.
 */
export function validateEquipmentDocumentFile(
  file: Pick<File, 'name' | 'type' | 'size'>
): EquipmentDocumentFileError | null {
  const isPdf =
    file.type === EQUIPMENT_DOCUMENT_FILE_CONSTRAINTS.mimeType ||
    (file.type === '' &&
      file.name.toLowerCase().endsWith(EQUIPMENT_DOCUMENT_FILE_CONSTRAINTS.extension));
  const hasValidSize =
    file.size > 0 && file.size <= EQUIPMENT_DOCUMENT_FILE_CONSTRAINTS.maxSizeBytes;

  return match<[boolean, boolean], EquipmentDocumentFileError | null>([isPdf, hasValidSize])
    .with([false, Pattern.boolean], always('notPdf'))
    .with([true, false], always('invalidSize'))
    .otherwise(always(null));
}
